const patientRoles = {
  LEGAL_REPRESENTATIVE: 'legal_representative',
  CARER: 'carer'
};

export {
  patientRoles
};
